import React, { useState, useContext, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useForm, Controller } from "react-hook-form";
import { UserInputData } from '../WarrantyFrame';
import CheckListTable from '../../../checkListTable'
import TextField from '@mui/material/TextField';

export default function InsForm10YT(props) {
    const { currentState, setCurrentState } = useContext(UserInputData);
    const { control, getValues, setValue, watch, formState: { errors } } = useForm({
        defaultValues: { ...currentState, ...currentState },
        mode: 'onChange'
    });
    const [valueOnChange, setValueOnChange] = useState(false)
    const [isComplete, setIsComplete] = useState(0)
    const [resetValues, setResetValues] = useState(false)

    const watchValues = watch()

    useEffect(() => {
        let upDateArray = JSON.parse(JSON.stringify(currentState));
        upDateArray = getValues();
        setCurrentState(upDateArray)
    }, [valueOnChange])

    useEffect(() => {
        //親フォームで取得した点検項目の値をセット
        if (currentState) {
            Object.entries(currentState).forEach(([key, value]) => {
                setValue(key, value)
            })
            setIsComplete(isComplete + 1)
        }
    }, [props.isEffectDone])

    useEffect(() => {
        //セットした値を元にチェックボックスへ反映
        if (isComplete === 2) {
            setResetValues(!resetValues)
        }
    }, [isComplete])

    //useEffectの第2引数にwatchValuesを設定
    //valueOnChangeを切り替える
    //→valueOnChangeが切り替わったタイミングでcurrentStateを更新するため
    useEffect(() => {
        if (isComplete === 2) {
            setValueOnChange(!valueOnChange)
        }
    }, [watchValues])

    const handleCheckListValues = (returnValue) => {
        if (!Object.keys(returnValue)[0]) return;
        for (let i = 0; i < Object.keys(returnValue).length; i++) {
            setValue(Object.keys(returnValue)[i], String(Object.values(returnValue)[i]))
        }
        setValueOnChange(!valueOnChange)
    };

    const validationRules = {
        gaibuTategu: {
            validate: (value) => {
                if (value) {
                    let check = true
                    for (let i = 0, len = value.length; i < len; i++) {
                        if (!value[i].match(/^[0-9]$/)) { // 半角数字判定
                            check = false
                        }
                    }
                    if (check === false) {
                        return "半角数字2桁で入力してください";
                    }
                }
            }
        },
    }

    return (
        <React.Fragment>
            <Typography sx={{ fontSize: '2rem', }}>4　定期点検項目</Typography>
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>外部</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>1.基礎</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="kiso"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'kisoHudoTinka',
                                        label: '不同沈下',
                                        value: parseInt(getValues("kisoHudoTinka"))
                                    }, {
                                        id: 'kisoKiretu',
                                        label: '亀裂',
                                        value: parseInt(getValues("kisoKiretu"))
                                    }, {
                                        id: 'kisoSonota',
                                        label: 'その他',
                                        value: parseInt(getValues("kisoSonota"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>2.外装材</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="gaisozai"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'gaisoWare',
                                        label: '割れ、欠け、ヒビ',
                                        value: parseInt(getValues("gaisoWare"))
                                    }, {
                                        id: 'gaisoJoint',
                                        label: 'ジョイント部シーリング',
                                        value: parseInt(getValues("gaisoJoint"))
                                    }, {
                                        id: 'gaisoToriaibu',
                                        label: '取合部シーリング',
                                        value: parseInt(getValues("gaisoToriaibu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                    <Typography sx={{ fontSize: '1.5rem', }}>外壁</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="gaiheki"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'gaihekiHenkei',
                                        label: '変形・不陸の有無',
                                        value: parseInt(getValues("gaihekiHenkei"))
                                    }, {
                                        id: 'gaihekiAmamizu',
                                        label: '雨水の浸入',
                                        value: parseInt(getValues("gaihekiAmamizu"))
                                    }, {
                                        id: 'gaihekiSonota',
                                        label: 'その他',
                                        value: parseInt(getValues("gaihekiSonota"))
                                    }]} />
                            )}
                        />
                    </Grid>

                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>3.バルコニー</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="balcony"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'barukoniRekka',
                                        label: '塗膜の劣化有無',
                                        value: parseInt(getValues("barukoniRekka"))
                                    }, {
                                        id: 'barukoniTukiStatus',
                                        label: '柱化粧飾の通気状態',
                                        value: parseInt(getValues("barukoniTukiStatus"))
                                    }, {
                                        id: 'barukoniMokubu',
                                        label: '木部の劣化',
                                        value: parseInt(getValues("barukoniMokubu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>4.屋根（目視）</Typography>
                    <Typography sx={{ fontSize: '1.2rem', }}>*ＯＰ；専門業者</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="roof"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'yaneTakezai',
                                        label: '屋根葺材',
                                        value: parseInt(getValues("yaneTakezai"))
                                    }, {
                                        id: 'yaneKabi',
                                        label: '苔、カビの発生',
                                        value: parseInt(getValues("yaneKabi"))
                                    }, {
                                        id: 'yaneNokisaki',
                                        label: '軒先、ケラバの状態',
                                        value: parseInt(getValues("yaneNokisaki"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>外部建具</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>1.全般</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="zenpan"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'zenpanTateguSokumen',
                                        label: '建具の側面',
                                        value: parseInt(getValues("zenpanTateguSokumen"))
                                    }, {
                                        id: 'zenpanTateguSita',
                                        label: '建具の下框',
                                        value: parseInt(getValues("zenpanTateguSita"))
                                    }, {
                                        id: 'zenpanKanaguSabi',
                                        label: '金具の錆',
                                        value: parseInt(getValues("zenpanKanaguSabi"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>2.防水</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="bousui"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'bousuiSanpo',
                                        label: '三方シーリング',
                                        value: parseInt(getValues("bousuiSanpo"))
                                    }, {
                                        id: 'bousuiSasikomi',
                                        label: '水切差込部',
                                        value: parseInt(getValues("bousuiSasikomi"))
                                    }, {
                                        id: 'bousuiRyoutan',
                                        label: '水切両端シーリング',
                                        value: parseInt(getValues("bousuiRyoutan"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>内部</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>1.内壁</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="naiheki"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'naihekiHenkei',
                                        label: '変形の有無',
                                        value: parseInt(getValues("naihekiHenkei"))
                                    }, {
                                        id: 'naihekiTawami',
                                        label: 'たわみの有無',
                                        value: parseInt(getValues("naihekiTawami"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>2.床</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="yuka"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'yukaHenkei',
                                        label: '変形の有無',
                                        value: parseInt(getValues("yukaHenkei"))
                                    }, {
                                        id: 'yukaHuroku',
                                        label: '不陸の有無',
                                        value: parseInt(getValues("yukaHuroku"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>3.小屋裏</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="koya"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'koyauraAmesome',
                                        label: '雨染みの有無',
                                        value: parseInt(getValues("koyauraAmesome"))
                                    }, {
                                        id: 'koyauraDannetu',
                                        label: '断熱材の状態',
                                        value: parseInt(getValues("koyauraDannetu"))
                                    }, {
                                        id: 'koyauraKouzo',
                                        label: '構造材の劣化有無',
                                        value: parseInt(getValues("koyauraKouzo"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>4.床下</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="yukashita"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'yukasitaSitudo',
                                        label: '床下湿度の状態',
                                        value: parseInt(getValues("yukasitaSitudo"))
                                    }, {
                                        id: 'yukasitaDannetuzai',
                                        label: '断熱材の状態',
                                        value: parseInt(getValues("yukasitaDannetuzai"))
                                    }, {
                                        id: 'yukasitaKouzouzai',
                                        label: '構造材の劣化有無',
                                        value: parseInt(getValues("yukasitaKouzouzai"))
                                    }, {
                                        id: 'yukaistaKiso',
                                        label: '基礎の状態',
                                        value: parseInt(getValues("yukaistaKiso"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>5.地下室の防水</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="chikashitsu"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'tikasituKabi',
                                        label: 'カビ、異臭の有無',
                                        value: parseInt(getValues("tikasituKabi"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>

            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>換気</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>1.空調、換気設備</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="kucho"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'kutyoNetukoukan',
                                            label: '熱交換素子の状態',
                                            value: parseInt(getValues("kutyoNetukoukan"))
                                        }, {
                                            id: 'kutyoKyokusyo',
                                            label: '局所換気の状態',
                                            value: parseInt(getValues("kutyoKyokusyo"))
                                        }, {
                                            id: 'kutyoGaibu',
                                            label: '外部フードの状態',
                                            value: parseInt(getValues("kutyoGaibu"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>白蟻</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>白蟻点検</Typography>
                        <Typography sx={{ fontSize: '1.2rem', }}>＊専門業者</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="shiroari"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'siroariSyokugai',
                                            label: '食害の有無',
                                            value: parseInt(getValues("siroariSyokugai"))
                                        }, {
                                            id: 'siroariUb',
                                            label: 'ＵＢ床下の状態',
                                            value: parseInt(getValues("siroariUb"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>確認項目</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>防火ダンパー付外部給排気口</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="boukadanpa"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'bousuiDanpaFuzu',
                                            label: 'ヒューズ切有無',
                                            value: parseInt(getValues("bousuiDanpaFuzu"))
                                        }, {
                                            id: 'bousuiDanpaYogore',
                                            label: '汚れ、目詰まり',
                                            value: parseInt(getValues("bousuiDanpaYogore"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>火災警報器</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="kasai"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'kasaiKeihouKigen',
                                            label: '使用期限',
                                            value: parseInt(getValues("kasaiKeihouKigen"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>玄関ドア　金具類</Typography>
                        <Typography sx={{ fontSize: '1.2rem', }}>＊交換の目安10年</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="genkan"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'genkanSirinder',
                                            label: 'シリンダー',
                                            value: parseInt(getValues("genkanSirinder"))
                                        }, {
                                            id: 'genkanLockCase',
                                            label: 'ロックケース',
                                            value: parseInt(getValues("genkanLockCase"))
                                        }, {
                                            id: 'genkanKurozer',
                                            label: 'クローザー　他',
                                            value: parseInt(getValues("genkanKurozer"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>排水管洗浄の必要</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="haisuikan"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'haisuikanKittin',
                                            label: 'キッチン・食洗機',
                                            value: parseInt(getValues("haisuikanKittin"))
                                        }, {
                                            id: 'haisuikanYokushitsu',
                                            label: '浴室、洗面所他',
                                            value: parseInt(getValues("haisuikanYokushitsu"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>外部建具の点検結果</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.障子部の補強対象</Typography>
                        <Grid container item xs={12}>
                            <Controller
                                name="tenkenSyozi"
                                control={control}
                                defaultValue=""
                                rules={validationRules.gaibuTategu}
                                render={({ field,fieldState }) => (
                                    <TextField
                                        {...field}
                                        inputProps={{
                                            maxLength: 2,
                                            style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                        }}
                                        variant="standard"
                                        error={fieldState.invalid}
                                        sx={{ width: "90%" }}
                                        helperText={errors.tenkenSyozi?.message} />
                                )}
                            />
                            <Typography sx={{ fontSize: '1.5rem', }}>ヵ所</Typography>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>2.金具、木部の修理対象</Typography>
                        <Grid container item xs={12}>
                            <Controller
                                name="tenkenKanagu"
                                control={control}
                                defaultValue=""
                                rules={validationRules.gaibuTategu}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        inputProps={{
                                            maxLength: 2,
                                            style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                        }}
                                        variant="standard"
                                        error={fieldState.invalid}
                                        sx={{ width: "90%" }}
                                        helperText={errors.tenkenKanagu?.message} />
                                )}
                            />
                            <Typography sx={{ fontSize: '1.5rem', }}>ヵ所</Typography>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>3.障子の交換対象</Typography>
                        <Grid container item xs={12}>
                            <Controller
                                name="tenkenSyouzi"
                                control={control}
                                defaultValue=""
                                rules={validationRules.gaibuTategu}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        inputProps={{
                                            maxLength: 2,
                                            style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                        }}
                                        variant="standard"
                                        error={fieldState.invalid}
                                        sx={{ width: "90%" }}
                                        helperText={errors.tenkenSyouzi?.message} />
                                )}
                            />
                            <Typography sx={{ fontSize: '1.5rem', }}>ヵ所</Typography>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>4.その他</Typography>
                        <Grid container item xs={12}>
                            <Controller
                                name="tenkenSonota"
                                control={control}
                                defaultValue=""
                                rules={validationRules.gaibuTategu}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        inputProps={{
                                            maxLength: 2,
                                            style: { fontSize: '1.5rem', backgroundColor: '#f5f8fa' }
                                        }}
                                        variant="standard"
                                        error={fieldState.invalid}
                                        sx={{ width: "90%" }}
                                        helperText={errors.tenkenSonota?.message} />
                                )}
                            />
                            <Typography sx={{ fontSize: '1.5rem', }}>ヵ所</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Typography sx={{ fontSize: '2rem', }}>＊個別の内容は別紙に記録する。</Typography>
            </Grid >
            <Typography sx={{ fontSize: '1.6rem', }}>＊屋根の点検は基本的に目視点検となります。</Typography>
        </React.Fragment>
    )
}
